import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Command, Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9FA] text-[#09090B] px-6">
      <div className="w-full max-w-sm">
        <Link to="/login" className="flex items-center gap-2 text-muted-foreground hover:text-[#09090B] transition-colors text-sm mb-8">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
        <div className="h-10 w-10 bg-primary flex items-center justify-center mb-6"><Command className="h-5 w-5 text-white" /></div>
        {sent ? (
          <div>
            <MailCheck className="h-8 w-8 text-[#10B981] mb-4" />
            <h1 className="font-heading font-bold text-2xl">Check your email</h1>
            <p className="text-sm text-muted-foreground mt-2">If an account exists for <span className="text-[#09090B]">{email}</span>, we've sent a password reset link. It expires in 1 hour.</p>
            <Link to="/login" className="mt-6 inline-block text-sm text-primary hover:underline">Return to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-bold text-2xl">Forgot password?</h1>
            <p className="text-sm text-muted-foreground mt-2 mb-6">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-white border-black/10 rounded-none h-11" />
              </div>
              {error && <p data-testid="forgot-error" className="text-sm text-destructive bg-destructive/10 border border-destructive/30 px-3 py-2">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 rounded-none bg-primary hover:bg-[#09090B] transition-colors font-medium">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
